"use strict";

var React = require('react'),
    $ = require('jquery'),
    Constants = require('../../constants'),
    ReactRouter = require('react-router'),
    RouteHandler = ReactRouter.RouteHandler,
    BS = require('react-bootstrap'),
    ProjectModel = require('../../models/Project'),
    Application = require('../Application'),
    AppWrap = require('./AppWrap');


var ToolboxApplication = React.createClass({displayName: "ToolboxApplication",
    contextTypes: {
        router: React.PropTypes.func
    },

    updateState: function(props) {
        var state = this.state || {},
            query = this.context.router.getCurrentQuery(),
            APICode = query.API,
            builder = this.props.builder,
            project;

        props = props || this.props;
        Constants.search = query;

        if (builder && APICode && builder.get('apiKey') !== APICode) {
            project = state.project || new ProjectModel({
                name: ':LISTING:'
            });

            if (!state.project || APICode !== state.project.get('apiKey')) {
                project.fetchByAPICode(APICode);
            }
        }

        return {
            project: project
        };
    },

    getInitialState: function() {
        return this.updateState();
    },
    /**
     * This is to ensure that when subroutes transistion they trigger recheck router state and render
     */
    componentWillReceiveProps: function(props) {
        this.setState(this.updateState(props));
    },

    render: function() {
        return (
            React.createElement(AppWrap, React.__spread({},  this.props, {project: this.props.project || this.state.project, title: this.props.title}))
        );
    }
});

module.exports = ToolboxApplication;
